export default __webpack_public_path__ + "static/media/close.d4bbb10b.svg";